import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CONDITIONS } from "@/data/conditions";

export default function ConditionsTeaser() {
  return (
    <section className="py-24 lg:py-32" data-testid="conditions-teaser">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="eyebrow mb-3">How can we help you?</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight max-w-2xl">
              Eight reasons people come back, week after week.
            </h2>
          </div>
          <Link
            to="/conditions"
            className="text-sm border-b border-current pb-0.5 inline-flex items-center gap-1.5"
            style={{ color: "var(--sano-olive)" }}
            data-testid="conditions-see-all"
          >
            See all conditions <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px" style={{ background: "var(--sano-border)" }}>
          {CONDITIONS.map((c) => (
            <Link
              key={c.slug}
              to={`/conditions/${c.slug}`}
              className="block p-7 hover:bg-[#F0EBE1] transition-colors group"
              style={{ background: "var(--sano-bg)" }}
              data-testid={`conditions-teaser-${c.slug}`}
            >
              <div className="eyebrow mb-3" style={{ color: "var(--sano-olive)" }}>{c.eyebrow}</div>
              <h3 className="font-serif-display text-xl leading-tight mb-3">{c.title}</h3>
              <span className="inline-flex items-center gap-1.5 text-sm" style={{ color: "var(--sano-ink-2)" }}>
                Learn more <ArrowRight size={13} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
